var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductShowcaseOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944,624H866a193.27,193.27,0,0,0-130,50V589.72C843.49,574.34,926.35,482.66,928,371.3c0-1.09,0-2.2,0-3.3a128,128,0,0,0-224-84.65A128,128,0,0,0,480,368c0,1.1,0,2.21,0,3.3,1.61,111.36,84.47,203,192,218.42V642a193.27,193.27,0,0,0-130-50H432a16,16,0,0,0-16,16V718c0,107.14,86.86,194,194,194H766c107.14,0,194-86.86,194-194V640A16,16,0,0,0,944,624ZM544,370.38v-.7c0-.56,0-1.12,0-1.68a64,64,0,0,1,112-42.31l48,54.38,48-54.38A64,64,0,0,1,864,368c0,.56,0,1.12,0,1.68v.7a160,160,0,0,1-319.92,0ZM610,848A130,130,0,0,1,480,718V656h62A130,130,0,0,1,672,786v62ZM896,718A130,130,0,0,1,766,848H736V818A130,130,0,0,1,866,688h30Z",
    style: {
      fill: "#5b6673"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,440l33.89,40.05A8,8,0,0,0,416,474.89V418a32,32,0,0,0-7.42-20.49l-9.7-11.64a32,32,0,0,0-36.46-9.23L128,470.4V176H824a8,8,0,0,0,8-8V144a32,32,0,0,0-32-32H96a32,32,0,0,0-32,32V720a32,32,0,0,0,32,32H344a8,8,0,0,0,8-8V696a8,8,0,0,0-8-8H128V541Z",
    style: {
      fill: "#96a2b1"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductShowcaseOutlined);
export default __webpack_public_path__ + "static/media/productShowcaseOutlined.c25e7c654eec9b0e7a99fff48dc30a19.svg";
export { ForwardRef as ReactComponent };